import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const creativeMappingsState = (state: AppState) => state.creativeMappings.overview;

export const getCreativeMappingsProcessingState = createSelector(
    creativeMappingsState,
    ({ hasError, isProcessing, isDeleting, isSubmitted }) => ({
        hasError,
        isProcessing,
        isDeleting,
        isSubmitted,
    })
);

export const getCreativeMappings = createSelector(creativeMappingsState, ({ creativeMappings }) => creativeMappings);

export const getCreativeMappingById = (id?: number) =>
    createSelector(creativeMappingsState, ({ creativeMappings }) => {
        return creativeMappings.find((mapping) => mapping.id === id);
    });
